import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    firstSection: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      minWidth: 0,

      '& .MuiTypography-h1': {
        margin: '2rem 0 1.5rem',
      },

      '& .MuiTypography-h4': {
        fontWeight: 500,
        color: theme.palette.text.secondary,
      },
    },

    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',

      '& button': {
        height: 'auto',
        width: 'auto',
        minWidth: '14rem',
        padding: '1rem 1.5rem',
        margin: 0,
      },

      '& > button': {
        color: '#727970',
      },

      '& > div button:first-child': {
        color: theme.palette.primary.dark,
      },
    },
  }),
)
